import axios, { type AxiosError } from 'axios'

function urlFromAxiosError(error: AxiosError): string | undefined {
  const configUrl = error.config?.url
  if (typeof configUrl === 'string' && configUrl.length > 0) {
    return configUrl
  }

  const request = error.request as { url?: unknown } | undefined
  if (request && typeof request.url === 'string' && request.url.length > 0) {
    return request.url
  }

  return undefined
}

function digestFromError(error: Error): string | undefined {
  if (!('digest' in error)) {
    return undefined
  }

  const digest = error.digest
  if (typeof digest === 'string' || typeof digest === 'number') {
    return String(digest)
  }

  return undefined
}

export function errorAnalyticsPayload(error: unknown) {
  if (!(error instanceof Error)) {
    return {
      errorMessage: String(error),
      errorName: 'Non-Error thrown',
      errorStack: '',
    }
  }

  const axiosUrl = axios.isAxiosError(error)
    ? urlFromAxiosError(error)
    : error.cause && axios.isAxiosError(error.cause)
      ? urlFromAxiosError(error.cause)
      : undefined

  const errorDigest = digestFromError(error)
  const errorCauseDigest = error.cause instanceof Error ? digestFromError(error.cause) : undefined

  return {
    errorMessage: typeof error.message === 'undefined' ? '' : error.message,
    errorName: typeof error.name === 'undefined' ? '' : error.name,
    errorStack: typeof error.stack === 'undefined' ? '' : error.stack,
    ...(axiosUrl === undefined ? {} : { errorUrl: axiosUrl }),
    ...(errorDigest === undefined ? {} : { errorDigest }),
    ...(error.cause instanceof Error
      ? {
          errorCauseMessage: typeof error.cause.message === 'undefined' ? '' : error.cause.message,
          errorCauseName: typeof error.cause.name === 'undefined' ? '' : error.cause.name,
          errorCauseStack: typeof error.cause.stack === 'undefined' ? '' : error.cause.stack,
          ...(errorCauseDigest === undefined ? {} : { errorCauseDigest }),
        }
      : { errorCause: String(error.cause) }),
  }
}
